import styles from './SkipLink.module.css'

/**
 * Appears at the top of every page; only visible on focus.
 * Links to #main-content which every page layout must provide.
 */
export function SkipLink() {
  return (
    <a href="#main-content" className={styles.root}>
      Skip to main content
    </a>
  )
}
